import { NotificationManager } from "react-notifications";
import { Actions as INTEGRATION_ACTIONS } from "../../../../store/actions/integrationActions";

import { uniqBy } from "lodash";
import { createRequest } from "../../../common/helpers/RequestHelpers";

const quickbooksRequest = createRequest({
	urlPath: "/integrations/quickbooks",
	// local: true,
});

const integrationRequest = createRequest({
	urlPath: "/integrations",
	// local: true,
});

const Types = {
	QUICKBOOKS_OPTIONS: "QUICKBOOKS_OPTIONS",
	QUICKBOOKS_SAVING: "QUICKBOOKS_SAVING",
	QUICKBOOKS_SETTINGS: "QUICKBOOKS_SETTINGS",
	QUICKBOOKS_OPTIONS_LOADING: "QUICKBOOKS_OPTIONS_LOADING",
	QUICKBOOKS_SEND_DATA: "QUICKBOOKS_SEND_DATA",
};

const setImportingTimesheets = (status) => ({
	type: Types.QUICKBOOKS_SETTINGS,
	status,
});
const setQuickBooksSaving = (status) => ({
	type: Types.QUICKBOOKS_SAVING,
	status,
});
const setQuickBooksLoading = (status) => ({
	type: Types.QUICKBOOKS_OPTIONS_LOADING,
	status,
});
const updateQuickbooksOptions = (data) => ({
	type: Types.QUICKBOOKS_OPTIONS,
	data,
});

const connectQuickbooks = () => {
	return (dispatch, getState) => {
		const url = window.location.href;

		quickbooksRequest({
			method: "GET",
			path: `/connect`,
			query: { url },
		})
			.then(({ data }) => {
				window.location.href = data.url;
				dispatch(INTEGRATION_ACTIONS.integrationGetList());
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Connecting Quickbooks", "Connect Quickbooks");
			});
	};
};

const disconnectQuickbooks = () => {
	return (dispatch, getState) => {
		quickbooksRequest({
			method: "POST",
			path: `/revoke`,
		})
			.then(({ data }) => {
				dispatch(INTEGRATION_ACTIONS.integrationGetList());
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Disconnecting Quickbooks", "Disconnect Quickbooks");
			});
	};
};

const getExpenseOptions = () => {
	return async (dispatch, getState) => {
		dispatch(setQuickBooksLoading(true));

		await quickbooksRequest({
			method: "GET",
			path: `/expenses`,
		})
			.then(({ data }) => {
				dispatch(updateQuickbooksOptions(data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Getting QuickBooks Expenses", "QuickBook Expenses");
			});

		dispatch(setQuickBooksLoading());
	};
};

const updateQuickBooksDetails = (expenseSettings) => {
	return async (dispatch, getState) => {
		dispatch(setQuickBooksSaving(true));

		await integrationRequest({
			method: "POST",
			path: `/Quickbooks/update-settings`,
			body: expenseSettings,
		})
			.then(({ data }) => {
				NotificationManager.success("QuickBooks Settings Saved Successfully", "Saving QuickBooks Settings");
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving QuickBooks Settings", "Saving QuickBooks Settings");
			});

		dispatch(setQuickBooksSaving(false));
	};
};

const setSendingData = (periodId, status) => ({
	type: Types.QUICKBOOKS_SEND_DATA,
	periodId,
	status,
});

const sendPayPeriodToQuickbooks = (payrun) => {
	return async (dispatch, getState) => {
		NotificationManager.info(`Sending Payroll Data`, "Sending Payroll to QuickBooks");

		dispatch(setSendingData(payrun, true));

		await quickbooksRequest({
			method: "POST",
			path: `/payrun`,
			body: { payrun },
		})
			.then(({ data }) => {
				dispatch(getExpenseOptions());
				NotificationManager.success(
					`Payroll Data has been sent successfully!`,
					"Sending Payroll to QuickBooks",
				);
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(`Error Sending Payroll Data`, "Sending Payroll to QuickBooks");
			});

		dispatch(setSendingData(payrun));
	};
};

const updateVendorList = (vendorList) => {
	return (dispatch, getState) => {
		const state = getState();

		const existingVendorList = state?.integration?.accounting?.quickbooks?.vendorList || [];

		if (!Array.isArray(vendorList)) {
			vendorList = [vendorList];
		}

		dispatch(
			updateQuickbooksOptions({
				vendorList: uniqBy([...vendorList, ...existingVendorList], "value"),
			}),
		);
	};
};

const updateLinks = (links) => {
	return (dispatch, getState) => {
		const state = getState();

		const existingLinks = state?.integration?.accounting?.quickbooks?.links || [];

		if (!Array.isArray(links)) {
			links = [links];
		}

		dispatch(
			updateQuickbooksOptions({
				links: uniqBy([...links, ...existingLinks], "agreement"),
			}),
		);
	};
};

const getQuickbooksContacts = async ({ query }) => {
	return new Promise(async (resolve) => {
		await quickbooksRequest({
			method: "GET",
			path: `/vendor`,
			query: { query },
		}).then(({ data: Contacts }) => {
			console.debug(Contacts);
			if (!Contacts) resolve([]);
			else resolve(Contacts);
		});
	});
};

const createQuickbooksVendor = ({ agreement, name }) => {
	return async (dispatch, getState) => {
		dispatch(updateQuickbooksOptions({ creatingVendor: true }));

		await quickbooksRequest({
			method: "POST",
			path: `/vendor`,
			body: { agreement, name },
		})
			.then(({ data }) => {
				const { vendor, employeeLink } = data;
				dispatch(updateVendorList(vendor));
				if (employeeLink) dispatch(updateLinks({ ...employeeLink, label: vendor.label }));
				NotificationManager.success(
					`Vendor "${vendor.label}" Created Successfully`,
					"Creating QuickBooks Vendor",
				);
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(`Error Creating QuickBooks Vendor`, "Creating QuickBooks Vendor");
			});

		dispatch(updateQuickbooksOptions({ creatingVendor: undefined }));
	};
};

const getQuickbooksEmployees = () => {
	return async (dispatch, getState) => {
		const state = getState();
		if (state.integration?.accounting?.quickbooks?.loadingEmployees) return;
		dispatch(updateQuickbooksOptions({ loadingEmployees: true }));

		await quickbooksRequest({
			method: "GET",
			path: `/employees`,
		})
			.then(({ data }) => {
				const { links, employees: vendorList } = data;
				dispatch(updateQuickbooksOptions({ links, vendorList }));
			})
			.catch((error) => {
				console.error(error);
			});

		dispatch(updateQuickbooksOptions({ loadingEmployees: undefined }));
	};
};

const linkEmployee = ({ agreement, referenceLink }) => {
	return async (dispatch, getState) => {
		if (referenceLink === "desynced") dispatch(updateQuickbooksOptions({ desyncingVendor: true }));

        await integrationRequest({
            method: "POST",
            path: `/Quickbooks/link-employee`,
            body: { agreementId: agreement, link: referenceLink },
        })
            .then(({ data }) => {
                dispatch(getQuickbooksEmployees());
            })
            .catch((error) => {
                console.error(error);
                NotificationManager.error("Error Linking Employee with Quickbooks", "Linking Employee with Quickbooks");
            });

		if (referenceLink === "desynced") dispatch(updateQuickbooksOptions({ desyncingVendor: undefined }));
	};
};

const Actions = {
	getQuickbooksEmployees,
	linkEmployee,
	connectQuickbooks,
	disconnectQuickbooks,
	getExpenseOptions,
	updateQuickBooksDetails,
	setQuickBooksLoading,
	sendPayPeriodToQuickbooks,
	getQuickbooksContacts,
	createQuickbooksVendor,
	updateVendorList,
	getQuickbooksEmployees,
	updateLinks,
};

export { Actions, Types };
